<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";
const props = defineProps<EditControlProps>();
const emitFn = defineEmits<CommonEditControlEmits>();

let min: number = 0;
let max: number = 5;

const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
var uiData = reactive(ui);

const uidata = reactive<EditorControlUiData>(uiData);
onMounted(() => {
  mounted(uidata, props, config);
});
function checkedChanged(txt: any) {
  valueChanged(config, uidata, uiData.data);
}
</script>
<template>
  <div class="wrap" v-if="uiData.showMutable">
    <v-tooltip
      v-model="uiData.showtooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
      :disabled="!uiData.showtooltip || !uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-slider
          v-bind="props"
          :label="uiData.description"
          :disabled="uiData.disabled"
          v-model="uiData.data"
          @update:modelValue="checkedChanged"
          :min="min"
          :max="max"
          thumb-label="always"
          track-color="blue"
          show-ticks="always"
          tick-size="4"
          inverse-label
          step="1"
          density="compact"
          tile
          style="padding-left: 8px"
        ></v-slider>
        <ValueChangeTracker v-if="uiData.isChanged || props.disableValueChangeTracker" />
      </template>
    </v-tooltip>
  </div>
</template>

<style scoped>
.v-label {
  font-size: 14px;
  margin-left: 5px;
}
</style>
